import React from 'react';

import Field from 'components/Field';
import MaterialInput from 'components/MaterialInput';
import { Desktop, Mobile } from 'components/Responsive';

import { Input } from './styles';

interface Props {
  name: string;
  placeholder?: string;
  mask?: string | Array<string | RegExp>;
  type?: string;
}

const ResponsiveInput = ({ name, placeholder, mask, type }: Props) => (
  <>
    <Desktop>
      <Field name={name}>
        <Input placeholder={placeholder} mask={mask} autoCapitalize="off" autoCorrect="off" type={type} />
      </Field>
    </Desktop>
    <Mobile>
      <MaterialInput name={name} placeholder={placeholder} type={type} mask={mask} />
    </Mobile>
  </>
);

export default ResponsiveInput;
